import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-google-signin-button',
  templateUrl: './google-signin-button.component.html',
  styleUrls: ['./google-signin-button.component.scss']
})
export class GoogleSigninButtonComponent {
  @Input() isLink: boolean = false;
  @Input() disabled: boolean = false;
}
